export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const tagMngrEnabled = String(config.public.tagMngrEnabled) === 'true';
  const tealiumSyncEnabled = String(config.public.tealiumSyncEnabled) === 'true';

  const account = String(config.public.tagMngrAccount || '');
  const env = String(config.public.tagMngrEnv || '');
  if (!tagMngrEnabled || !account || !env) {
    return;
  }

  if (!/^[a-zA-Z0-9_-]+$/.test(account) || !/^[a-zA-Z0-9_-]+$/.test(env)) {
    return;
  }

  const scripts = [];

  if (tealiumSyncEnabled) {
    scripts.push({
      key: 'tealium-utag-sync',
      src: `//tags.tiqcdn.com/utag/${account}/main/${env}/utag.sync.js`,
      type: 'text/javascript',
    });
  }

  scripts.push({
    key: 'tealium-utag-js',
    type: 'text/javascript',
    tagPosition: 'bodyClose',
    innerHTML: [
      'window.utag_cfg_ovrd = { noview: true };',
      'var utag_data = utag_data || {};',
      "utag_data['page_type'] = 'my account';",
      "utag_data['page_name'] = 'loyalty home';",
      '(function () {',
      `  var a = '//tags.tiqcdn.com/utag/${account}/main/${env}/utag.js',`,
      "    c = 'script',",
      '    d = document.createElement(c);',
      '  d.src = a;',
      "  d.type = 'text/java' + c;",
      '  d.async = true;',
      '  a = document.getElementsByTagName(c)[0];',
      '  a.parentNode.insertBefore(d, a);',
      '})();',
    ].join('\n'),
  });

  useHead({ script: scripts });
});
